exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".br-10[data-v-6888a164] {\n  border-radius: 10px;\n}\n.trigger[data-v-6888a164] {\n  padding: 8px 30px;\n  background: #ebebeb;\n}\n.btn-purple[data-v-6888a164] {\n  background: #6e7ff2;\n}\n.btn-yellow[data-v-6888a164] {\n  background: #f8f582;\n}\n.btn-light-green[data-v-6888a164] {\n  background: #9af6c0;\n}\n.btn-light-red[data-v-6888a164] {\n  background: #f87676;\n}\n", ""]);

// exports
